import React, { useEffect, useState } from "react";
import auth from "../../../core/auth";
import { useAlert } from "react-alert";
import Itemlist from "./itemlist";
import Mqtt_statusBar from "../../../mqtt/mqtt_statusbar";
const appparameters = require("../../../core/common.jsx");

export const ListView = (props) => {
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState({
    sites: [],
  });
  useEffect(() => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(auth.getUserData()),
    };

    fetch(
      appparameters.backend_app_url + "/frontend/getacountcontacts",
      requestOptions,
    )
      .then((response) => response.json())
      .then((responseData) => {
        //console.log("response data");
        //console.log(responseData);
        setState({
          sites: responseData,
        });
        setLoading(false);
      })
      .catch((error) => console.warn(error));
  }, []);
  if (loading) {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading ListView view ...</strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else if (state.sites.length > 0) {
    return (
      <div className="container">
        <Mqtt_statusBar />
        <div>
          <table className="table table-hover table-dark listviewtable header-fixed text-center loginrow">
            <thead>
              <tr>
                <th scope="col">Site ID</th>
                <th scope="col">Control</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {state.sites.map((site) => (
                <Itemlist
                  key={site.sitedetails[0]["_id"]}
                  index={site.sitedetails[0]["_id"]}
                  siteId={site.sitedetails[0]["Surf ID"]}
                  siteInformation={site["location_name"]}
                  siteDescription={site["description"]}
                  hardwareversion={site.sitedetails[0]["Hardware Version"]}
                  softwareversion={site.sitedetails[0]["Software Version"]}
                  revisionnumber={site.sitedetails[0]["Revision Number"]}
                  serialnumber={site.sitedetails[0]["Serial Number"]}
                  type={site.sitedetails[0]["Type"]}
                  SDPresence={site.sitedetails[0]["SD Presence"]}
                  mac={site.sitedetails[0]["Mac"]}
                  latitude={site["latitude"]}
                  longitude={site["longitude"]}
                  mail={site["mail"]}
                  subtype={site.sitedetails[0]["SubType"]}
                  userpass={site.sitedetails[0]["Surf Password"]}
                  clientpass={site.sitedetails[0]["Client Password"]}
                  seniorpass={site.sitedetails[0]["Senior Password"]}
                  saspass={site.sitedetails[0]["SAS Password"]}
                  designtype={site.sitedetails[0]["Design Type"]}
                  timezone={site.sitedetails[0]["TimeZone"]}
                  fu={site.sitedetails[0]["Firmware Upgrade"]}
                  lr={site.sitedetails[0]["Log Retrieve"]}
                  fl={site.sitedetails[0]["Faults Log"]}
                  fr={site.sitedetails[0]["Fault Reset"]}
                  entered_pass={site["entered_pass"]}
                  lastseen="N/A"
                  status="N/A"
                  parentPropsHistory={props.history}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container">
        <div>
          <img src={require("./../../../images/sadface.svg")} />
          <h6 />
          <h6>Empty account</h6>
          <h7>Click add site above to add a new device</h7>
        </div>
      </div>
    );
  }
};
